import { InformationFilled, StarFilled, Star } from '@carbon/icons-react'
import { MessagesModalGeneric } from './components/MessagesModalGeneric'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import useRateVideoCall from './hooks/useRateVideoCall'

import { useLocation } from 'react-router-dom'


interface MeetingEndedScreenProps {
  updateFavicon?: (brand: string) => void
  documentTitle?: string
}

const MeetingEndedScreen = ({
  updateFavicon,
  documentTitle,
}: MeetingEndedScreenProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const [rating, setRating] = useState<number | null>(null)
  const [showSecondModal, setShowSecondModal] = useState(false)
  const [hoveredStar, setHoveredStar] = useState<number | null>(null)

  const { rateVideoCall, loading } = useRateVideoCall()
  const [roomId, setRoomId] = useState<string>('')
  const searchParams = new URLSearchParams(location.search)
  const brand = searchParams.get('brand') || ''

  useEffect(() => {
    const storedRoomId = localStorage.getItem('zoom_room_id') || ''
    setRoomId(storedRoomId)


    const hasRated = localStorage.getItem(`zoom_call_rated_${storedRoomId}`)
    if (hasRated === 'true') {
      setShowSecondModal(true)
    }
    if (updateFavicon && brand) {
      updateFavicon(brand)
    }

    if (documentTitle) {
      document.title = documentTitle
    }
  }, [brand, updateFavicon, documentTitle])

  const handleRating = async (value: number) => {
    setRating(value)

    try {
      await rateVideoCall({
        room_id: roomId,
        rating: value,
      })
      localStorage.setItem(`zoom_call_rated_${roomId}`, 'true')
      setShowSecondModal(true)
    } catch (error) {
      console.error('Error rating video call:', error)
      setShowSecondModal(true)
    }
  }

  const handleCloseSecondModal = () => {
    setShowSecondModal(false)
    window.location.href = '/'
  }

  return (
    <div className="text-[20px]">
      {!showSecondModal && (
        <MessagesModalGeneric
          onClose={() => (window.location.href = '/')}
          description=""
          title=""
          className2="!py-0 !my-0 !px-6"
        >
          <div className="-mt-[28px] pb-4">
            <h2 className="mb-6 pt-2 md:pt-0">
              {t('zoom.endMeeting.modal1Title')}
            </h2>

            <div className="flex flex-col items-center justify-center gap-5 rounded-2xl border border-[#E5E5E5] bg-white p-6">
              <p className="text-center mb-4">
                {t('zoom.endMeeting.modal1Question')}
              </p>

              <div className="flex items-center justify-center w-full">
                <div className="flex gap-6">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <div
                      key={star}
                      onClick={() => handleRating(star)}
                      onMouseEnter={() => setHoveredStar(star)}
                      onMouseLeave={() => setHoveredStar(null)}
                      className={`cursor-pointer transition-transform duration-200 ${
                        rating === star ? 'scale-125' : ''
                      } ${loading ? 'opacity-50 pointer-events-none' : ''}`}
                      style={{
                        borderRadius: '4px',
                        padding: '2px',
                      }}
                    >
                      {rating && star <= rating ? (
                        <StarFilled
                          size={30}
                          style={{
                            color:
                              hoveredStar && star <= hoveredStar
                                ? '#F7E06D'
                                : 'currentColor',
                          }}
                        />
                      ) : (
                        <Star
                          size={30}
                          style={{
                            color:
                              hoveredStar && star <= hoveredStar
                                ? '#F7E06D'
                                : 'currentColor',
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-between gap-2 w-full">
                <span>{t('zoom.endMeeting.modal1ValueBad')}</span>
                <span>{t('zoom.endMeeting.modal1ValueGood')}</span>
              </div>
            </div>
          </div>
        </MessagesModalGeneric>
      )}

      {showSecondModal && (
        <MessagesModalGeneric
          onClose={handleCloseSecondModal}
          description=""
          title=""
          className2="!py-4 !px-6 !text-[20px]"
          icon={<InformationFilled size={42} style={{ color: '#02918a' }} />}
        >
          <h2 className="mb-6">{t('zoom.endMeeting.modal2ThankYou')}</h2>
          <p className="my-2 font-normal whitespace-pre-line">
            {t('zoom.endMeeting.modal2Contact')}
          </p>
        </MessagesModalGeneric>
      )}
    </div>
  )
}

export default MeetingEndedScreen
